import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { IFabricationMockup } from '../../../../../../store/ducks/fabrication-mockups/types';
import { ERoutes } from '../../../../../../routes';
import { EProjectsMockupsRoutes } from '../../../../projectsMockup.routes';
import { setEditingMockup } from '../../../../../../store/ducks/fabrication-mockups/actions';
import RemoveMockup from './RemoveMockup';
import DuplicateMockup from './DuplicateMockup';
import { ApplicationState } from '../../../../../../store';
import { Button, Icon } from '@gerdau/hefesto';
import { InformationPanel } from '@gerdau/hefesto-mais-web/InformationPanel';
import { getTaggingInformationScreen } from '../../../../../../utils/Tagging';
import { sendTagging } from '../../../../../../store/ducks/tagging/actions';

interface IViewOptionsButtonProps {
  contractNumber: string;
  mockup: IFabricationMockup;
  mockups: IFabricationMockup[];
}

const ViewOptionsButton: React.FC<IViewOptionsButtonProps> = ({
  contractNumber,
  mockup,
  mockups
}) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const { screenName = '', itemDescription = '' } = getTaggingInformationScreen(
    'tabela-maquetes-opcoes'
  );

  const hasAssociatedProjects = mockup.pavements.some(
    (p) => p.projects && p.projects.length > 0
  );

  const hasAssociatedOrders = mockup.pavements.some(
    (p) => p.orders && p.orders.length > 0
  );

  const mockupsState = useSelector(
    (appstate: ApplicationState) => appstate.fabricationMockups
  );

  const [canShowRemoveModal, setCanShowRemoveModal] = useState(false);
  const [canShowDuplicateModal, setCanShowDuplicateModal] = useState(false);

  const onEditClick = () => {
    dispatch(setEditingMockup(mockup.id));
    history.push(
      `${ERoutes.PROJECT_MOCKUP}${EProjectsMockupsRoutes.MOCKUP_VIEW}`
    );
  };

  const onDuplicateClick = () => {
    if (mockupsState.saveMockupState?.editingMockupId) {
      dispatch(setEditingMockup());
    }
    setCanShowDuplicateModal(true);
  };

  return (
    <>
      <InformationPanel
        title="Opções"
        position={'bottom right'}
        panelOptions={[
          {
            handleOnClick: () => {
              onDuplicateClick();
              dispatch(
                sendTagging({
                  screenName,
                  itemName: 'button:duplicarMaquete',
                  itemDescription: `${itemDescription}_duplicarMaquete`,
                  event: 'click'
                })
              );
            },
            text: 'Duplicar maquete'
          },
          {
            handleOnClick: () => {
              onEditClick();
              dispatch(
                sendTagging({
                  screenName,
                  itemName: 'button:editar',
                  itemDescription: `${itemDescription}_editar`,
                  event: 'click'
                })
              );
            },
            text: 'Editar'
          },
          {
            handleOnClick: () => {
              setCanShowRemoveModal(true);
              dispatch(
                sendTagging({
                  screenName,
                  itemName: 'button:apagar',
                  itemDescription: `${itemDescription}_apagar`,
                  event: 'click'
                })
              );
            },
            text: 'Apagar',
            disabled: hasAssociatedProjects || hasAssociatedOrders
          }
        ]}
        trigger={
          <div data-testid="mockups-view-options-button">
            <Button
              name="options"
              variant="neutral"
              icon={<Icon option="MoreVertical" />}
            />
          </div>
        }
      />

      {canShowRemoveModal && (
        <RemoveMockup
          mockupId={mockup.id}
          mockupName={mockup.name}
          contractNumber={contractNumber}
          onCancel={() => setCanShowRemoveModal(false)}
        />
      )}

      {canShowDuplicateModal && (
        <DuplicateMockup
          contractNumber={contractNumber}
          mockup={mockup}
          listOfMockupsNames={mockups.map((m) => m.name)}
          onCancel={() => setCanShowDuplicateModal(false)}
        />
      )}
    </>
  );
};

export default ViewOptionsButton;
